<template>
    <main id="main">
        <b-navbar toggleable="lg" type="dark" variant="info" id="navbar" :sticky="true">
            <b-navbar-brand href="#"><router-link to="/"><font-awesome-icon id="font" icon="arrow-left" /></router-link><span id="span">{{$t('social_support')}}</span></b-navbar-brand>
        </b-navbar>
  <b-container class="mt-4 mx-3 overflow-auto se-cards" id="fir">
    <span class="d-block h5 mx-2 mt-4 pl-1">{{$t('Social_support_highlight')}}</span>
  </b-container>
  <b-container class="mt-4 mx-3 px-0 containerView borderColor" v-for="item in govtinitiatives" :key="item.heading">
    <span class="py-2 bgcolor borderColor nutrition-card-header">{{$t( item.heading) }}</span>
    <p class="mt-3 mx-2">{{ $t(item.description) }}</p>
  </b-container>
  <br>
    </main>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Govtinitiatives',
  computed: {
    ...mapState([
      'govtinitiatives'
    ])
  }
}
</script>
